import { render, staticRenderFns } from "./VideoSessions.vue?vue&type=template&id=55cf447d"
import script from "./VideoSessions.vue?vue&type=script&lang=js"
export * from "./VideoSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports